import { useGet } from 'components/api'

const useGetDiscount = ({ token, bookableId, bookingDate, ...options }) => {
  const { data: discount, ...state } = useGet({
    path: `/discounts/${token}`,
    queryParams: {
      bookableId,
      bookingDate
    },
    resolve: (data) => {
      return data.discount
    },
    ...options
  })
  return {
    discount,
    ...state
  }
}

export default useGetDiscount
